import _ from 'lodash';
import {
    ARAG_USERS,
    SOLICITOR_USERS,
    ADMIN_USERS,
    AGENTS_USERS,
    COUNTRY,
    CANADA_COUNTRY,
    CURRENCY
} from './variables';
import {TERMINAL_POLICY_STATUSES_UK, TERMINAL_POLICY_STATUSES_CA, SYSTEM_OF_RECORD_GATEWAY_PLUTUS_LAWSYS, ARAG_PROVIDER_CODE_PLC} from './constants';
import accounting from 'accounting';
import moment from 'moment';
import CONTENT_STRINGS from './contentStrings';

//function that gets as an input a date string and returns a valid html date string
export function getHtmlValidDate(date){
    let splitDate = date.split('/');
    let dd,mm,yyyy;
    mm= splitDate[1];
    dd = splitDate[0];
    yyyy = splitDate[2];
    if(parseInt(splitDate[0]) < 10){
        dd = '0' + parseInt(splitDate[0])
    }
    else {
        dd = splitDate[0];
    }
    if(parseInt(splitDate[1]) < 10){
        mm = '0' + parseInt(splitDate[1])
    }
    else {
        mm = splitDate[1];
    }
    return yyyy + '-' + mm + '-' + dd;
}
export function getValidDate(date){
    let dateParts = date.split("/");

    // month is 0-based, that's why we need dataParts[1] - 1
    let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject;
}
//function that checks if the input is a valid json string
export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
//function that checks if logged in user is an arag user
export function isAragUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(ARAG_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is an agent  user
export function isAgent(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(AGENTS_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is a solicitor  user
export function isSolicitorUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(SOLICITOR_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is an admin  user
export function isAdminUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(ADMIN_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if input is email
export function isEmail(input){
    let reguralExp = /^(\w|')+([\.-]?(\w|')+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
    try {
        if(input.match(reguralExp)){
            return true;
        }
        else{
            return false;
        }
    }
    catch (e) {
        return false;
    }
}
//function that checks if input is phone
export function isPhone(input){
    let reguralExp = COUNTRY == CANADA_COUNTRY ? /^(?:(\+?1-?)|001-?)?(\d{3}-?){2}\d{4}$/ : /^(\+44|0|0044)\d{10}$/im;
    try {
        if(input.match(reguralExp)){
            return true;
        }
        else{
            return false;
        }
    }
    catch (e) {
        return false;
    }
}

export function formattedMoney(value, currency, precision = 2) {
   return accounting.formatMoney(value, `${currency} `, precision)
}

export const getLawsysArrayQueryParameter = (lawsys) => {
    try {
        return lawsys.reduce((current, next, index) => {
            const val = `lawsysIds=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const getArrayQueryParameterMachineName = (queryString, params) => {
    try {
        return params.reduce((current, next, index) => {
            const val = `${queryString}=${next.machineName}`;
            if (index === 0) {
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const getSolicitorUsersArrayQueryParameter = (lawsys) => {
    try {
        return lawsys.reduce((current, next, index) => {
            const val = `solicitorUsersIds=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
//constructs an array query param
export const getArrayPamaterer = (entity, queryString) => {
    try {
        return entity.reduce((current, next, index) => {
            const val = `${queryString}=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
//checks if the entity is selected by matching its machine name with the given collection
export const isEntitySelected = (machineNameToMatch, selectedEntities) => {
    //each item of the entity collection must have a property machineName to match
    try {
        return !!selectedEntities.find(entity => entity.machineName === machineNameToMatch);
    } catch (e) {
        return false;
    }
};
export const actionCreator = (actionType) => (payload) => ({
   type: actionType,
   payload: payload
});
export const areEntitiesWithIdsEqual = (firstEntity, secondEntity) => {
    const totalMatches = firstEntity.reduce((accumulator, currentItem) => {
        if(secondEntity.find(item => item.id === currentItem.id)) {
            return accumulator + 1;
        }
        return accumulator;
    }, 0);
    return (totalMatches === secondEntity.length) && (totalMatches === firstEntity.length);
};
export const getArrayQueryParameter = (updateFormQuestions, parameterName) => {
    try {
        return updateFormQuestions.reduce((current, next, index) => {
            const val = `${parameterName}=${next.value}`;
            if (index === 0) {
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const scrollToElement = (element, options) => {
    if(options) {
        window.scrollTo(options);
    } else {
        window.scrollTo(0, element.offsetTop);
    }
};
export const errorParser = (e) => {
    try {
        if (
            e
            && e.body
            && e.body.message
        ) {
            return e.body.message;
        }

        if (
            e
            && e.body
            && e.body.Message
        ) {
            return e.body.Message;
        }

    } catch (e) {
        return null;
    }
};
export const readFileAsBase64Async = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result.substring(reader.result.indexOf("base64,") + 7));
        };

        reader.onerror = reject;
    });
}
// Read a query-string parameter from a React Router location's `search` string (e.g. "?copyFrom=97").
// Always read the param this way for anything driven by in-app navigation: it uses the router's own
// location object, which stays correct even if something elsewhere does a raw
// window.history.replaceState (anything reading window.location.href would then see a stripped URL).
// Returns null when the param is absent or present-but-empty.
export const getRouterSearchParam = (search, name) => {
    return new URLSearchParams(search || '').get(name) || null;
};
export const downLoadFile = (name, base64Encoding, fileExtension) => {
    const src = `data:application/binary;base64,${base64Encoding}`;
    const fileName = name;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const byteCharacters = atob(base64Encoding);
        const byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/binary" });
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = src;
        downloadLink.download = fileName;
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
};
export const _getFileFromBase64 = (documentToDownload) => {
    downLoadFile(documentToDownload.name, documentToDownload.encodedFile, null);
};
// trims and replaces the new lines in the given string with semicolons
export const trimAndAddSemicolonsInsteadOfNewLines = (inputString, question) => {
    let output = inputString;
    if(!output) {
        return output
    }

    // if question is of type calendar remove semicolons
    // if(question && question.inputType === "calendar"){
    //     return  output.replace(/;/gi, "");
    // }

    // if last character is not semicolon, then add one at the end
    if(output.length > 0 && output[output.length - 1] !== ";" && output[output.length - 1] !== "\n"){
        // output = output + ";" ;
    }

    //  replace new lines with semicolons and remove whitespaces
    return output.replace(/\n/gi, ";");
};
export const getSortableColumnSortClass = (orderBy, orderAsc, property) => {
    if (orderBy !== property) {
        return ""
    }

    if (orderAsc) {
        return "sort-desc";
    }

    return "sort-asc";
};
//function return a specific value of an array of object
export const extractSpecificElementOfArray=(array,nestedArray,element)=>{
    let helperFunction = [];
    _.forEach(array, i => {
        _.forEach(i[nestedArray], s => {
            helperFunction.push({
                [element]: s[element]
            });
        })
    });
    return {
        helperFunction: helperFunction,
    }
}
export const fileToObjectHandle = async (file) => {
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
            resolve({
                name: file.name,
                encodedFile: fileReader.result.substring(fileReader.result.indexOf("base64,") + 7),
                fileType: file.type
            });
        };
        fileReader.onerror = reject;
        fileReader.readAsDataURL(file);
    });
}
export const stringToNumber = (stringParam) =>{
    const parsed = parseFloat(stringParam);
    return isNaN(parsed) ? 0 : parsed;
}
// For percentage fields auto-calculated from an amount (e.g. underwriterRatePercentage,
// commissionPercentage) — these legitimately carry up to 4 decimals since they're a ratio,
// not money. Never use this for a money amount.
export const roundToFourDecimals = (value) => parseFloat(value.toFixed(4));
// For amount fields (money, UK GBP or CA CAD) — 2 decimals max, even when the amount is
// itself derived from a percentage (e.g. underwriterRate/commission computed as percentage * premium).
export const roundToTwoDecimals = (value) => parseFloat(value.toFixed(2));

export const amountColumnsDisplayDataPerStage = (stage) => {
    const premiumAmount = stringToNumber(stage.premiumAmount);
    const limitOfIndemnityAmount = stringToNumber(stage.limitOfIndemnity);
    // underwriterRateAmount/commissionAmount are money amounts derived from a percentage —
    // round to 2dp for display since they represent money, not the percentage itself.
    const underwriterRateAmount = roundToTwoDecimals(stringToNumber(stage.underwriterRatePercentage) * 0.01 * premiumAmount);
    const commissionsAgentsData = stage.stagedPremiumSubSettingCommissionDtos.map(a => {
        const commissionAmount = roundToTwoDecimals(stringToNumber(a.commissionPercentage) * 0.01 * premiumAmount);
        return { title: a.lawsysName, value: commissionAmount, isPlain: true, onChange: () => null, isCommissionAgent: true, aragProvider: a.aragProvider };
    });
    return [
        {
            title: CONTENT_STRINGS.PREMIUM, value: premiumAmount, isPlain: false, onChange: (e) => null
        },
        {
            title: CONTENT_STRINGS.LIMIT_OF_INDEMNITY, value: limitOfIndemnityAmount, isPlain: false, onChange: (e) =>null
        },
        { 
            title: CONTENT_STRINGS.UNDERWRITER_RATE, value: underwriterRateAmount, isPlain: true, onChange: () => null
        },
        ...commissionsAgentsData
    ]
  }

  // validate amounts
export const validateAmount = (value, minimum, maxDecimals = 2) => {
    if (value === null || value === undefined) value = '';
    let errMsg = '';
    let s = value.toString().split(/\.|,/);
    try {
        if (s[0].length > 15) {
            errMsg = 'Value must be less than or equal to 999,999,999,999,999.99';
        } else if (s[1]?.length > maxDecimals) {
            errMsg = `Number input should have at most ${maxDecimals} decimals`;
        }
    } catch (e) {}

    if (isNaN(value) && value !== "") {
        errMsg = 'Input is not a valid number';
    }

    if (minimum !== undefined && minimum !== null) {
        try {
            const minValueNumber = parseFloat(minimum);
            const valueNumber = parseFloat(value);
            if (valueNumber < minValueNumber) {
                errMsg = `Minimum value is ${CURRENCY}${minValueNumber.toString()}`;
            }
        } catch (e) {}
    }
    return errMsg;
};

export const hasTooManyDecimals = (value) => {
    if (value === '' || value === null || value === undefined) return false;
    const stringValue = value.toString();
    // More than one decimal separator (e.g. "5.22.555.669") is malformed, not just imprecise —
    // checking parts[1] alone misses this, since parts[1] ("22") looks like a valid 2dp tail
    // while the rest of the string is silently dropped later by parseFloat/accounting.formatMoney.
    if ((stringValue.match(/[.,]/g) || []).length > 1) return true;
    const parts = stringValue.split(/[.,]/);
    return (parts[1]?.length ?? 0) > 2;
};

export const amountOnChange = (onChange, validate) => (e) => {
    if (!hasTooManyDecimals(e.target.value)) {
        onChange(e.target.name, e.target.value);
        validate(e.target.value);
    }
};

export const formatNumber = (value) => {
    if (!value) return '0';
    const num = parseFloat(value);
    const valueString = value.toString();

    if (Number.isInteger(num)) {
        return num.toString();
    } else {           
        return num.toFixed(2);
    }
};
export const _getQuestionAnswer = (answer) => {
    if(answer.optionId) return answer.optionName;
    if(answer.text) return answer.text;
    if(answer.amount) return accounting.formatMoney(answer.amount, `${CURRENCY} `, 2);
    if(answer.date) return moment(answer.date).format('DD/MM/YYYY');
    if(answer.answerAttachments) return answer.answerAttachments.map(a =>a.name).join(", ");
    return '';
};

export const reduceAnswers = (questionsWithAnswers) => {
    if (!questionsWithAnswers || !Array.isArray(questionsWithAnswers)) {
        return {};
    }
    const reducedAnswers = questionsWithAnswers.reduce((acc, item) => {
        acc[item.questionMachineName] = _getQuestionAnswer(item);
        return acc;
    }, {});
    return reducedAnswers;
}

export const changePage = (dispatch, changeField) => (page) => dispatch(changeField('page', page));

export const changePageSize = (dispatch, changeField) => (evt) =>
    dispatch(changeField('selectedView', parseInt(evt.target.value)));

export const goAtPrevious = (handlePageChange, currentPage) => () => {
    if (currentPage > 1) handlePageChange(currentPage - 1);
};

export const goAtNext = (handlePageChange, currentPage, totalPages) => () => {
    if (currentPage < totalPages) handlePageChange(currentPage + 1);
};

export const goAtStart = (handlePageChange) => () => handlePageChange(1);

export const goAtEnd = (handlePageChange, totalPages) => () => {
    if (totalPages > 0) handlePageChange(totalPages);
};

export const goAtPage = (handlePageChange) => (page) => handlePageChange(page);

export const TERMINAL_POLICY_STATUSES = COUNTRY == CANADA_COUNTRY ?  TERMINAL_POLICY_STATUSES_CA : TERMINAL_POLICY_STATUSES_UK;

export const redirectToHandler = (redirectToURL, history, successMsg) => {
    history.push({
        pathname: redirectToURL,
        state: 
        { 
            successMsg: successMsg ,
            isRedirection: true 
        }
    });
}

export const callbackHandler = (e, href, setIsNavbarOpen, push) => {
    e.preventDefault();
    push(href);
    setIsNavbarOpen(false);
}

export const filterActiveOptions = (options, selectedOptionId = null) => {
    if (!options) return [];
    return options.filter(option =>
        option.isActive !== false ||
        (selectedOptionId && option.id && option.id.toString() === selectedOptionId.toString())
    );
}

export const isValidEmail = (emailValue) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailValue) && emailValue !== '';
}

// Renders an option's label with a colored marker when option.aragProvider.providerColour is
// present (dropdown rows/selected value via formatOptionLabel, or a plain-variant display
// value passed directly). Renders nothing extra when aragProvider/providerColour is absent,
// markerClassName selects the marker shape: a dot for dropdown/searchableList rows, or a
// vertical colour bar (barely-visible as a dot in a dense row) for table cell formatters.
const formatOptionLabel = (option, markerClassName, markerInnerClassName) => (
    <span className={markerClassName}>
        {option?.aragProvider?.providerColour && (
            <span
                className={markerInnerClassName}
                style={{ backgroundColor: option.aragProvider.providerColour }}
            />
        )}
        {option?.label || ''}
    </span>
);

export const formatSolicitorOptionLabel = (option) => formatOptionLabel(option, 'dot-search-suggestion', 'policy-search-dot');

export const formatSolicitorTableLabel = (option) => formatOptionLabel(option, 'line-search-suggestion', 'policy-search-line');

// An existing solicitor group only accepts firms and underwriters of its own ARAG provider, so those
// are the only ones the edit form offers. A null/undefined groupAragProviderId means "not editing a
// group that has a provider" - creating a new group, or editing one that predates provider ownership -
// and then nothing is filtered out, because there is nothing to be consistent with.
//
// Firms and underwriters carry their provider differently: a firm has a nested aragProvider object
// (as the Lawsys search returns it), an underwriter a flat aragProviderId. Hence two functions rather
// than one - collapsing them would silently filter out everything on whichever shape lost.
const restrictsToAragProvider = (groupAragProviderId) =>
    groupAragProviderId !== null && groupAragProviderId !== undefined;

export const filterFirmsByAragProvider = (firms, groupAragProviderId) => {
    if (!restrictsToAragProvider(groupAragProviderId)) return firms || [];
    return (firms || []).filter(firm => firm && firm.aragProvider && firm.aragProvider.id === groupAragProviderId);
};

export const filterUnderwritersByAragProvider = (underwriters, groupAragProviderId) => {
    if (!restrictsToAragProvider(groupAragProviderId)) return underwriters || [];
    return (underwriters || []).filter(underwriter => underwriter && underwriter.aragProviderId === groupAragProviderId);
};

// The single-firm counterpart of filterFirmsByAragProvider, for the places that have to block one
// selection rather than narrow a list - a commission agent about to be added to a premium setting.
//
// Deliberately the exact complement of the filter: a firm the filter would have dropped is a firm this
// reports as outside the provider, including one whose own provider is unknown. Nothing (no firm
// selected yet) is never a mismatch - there is nothing to block.
export const isAgentOutsideAragProvider = (firm, groupAragProviderId) => {
    if (!restrictsToAragProvider(groupAragProviderId) || !firm) return false;
    return filterFirmsByAragProvider([firm], groupAragProviderId).length === 0;
};

// Which ARAG provider step 3 restricts its commission agents to: the provider of the group the setting
// is actually being saved against. That group is picked the same way the save body picks it - the
// setting's own group when editing, otherwise the group chosen on the Premium Settings page - so the
// wizard and the server can never end up comparing against two different groups.
//
// The fetched setting's own solicitorGroupAragProviderId is only a fallback, and only when editing: it
// is also populated when a setting is opened as a copy template (?copyFrom), where the group being
// written is the newly chosen one, not the template's. Null when no group is known (the application-premium
// flow) or the group has no provider, and then nothing is restricted.
// Single lookup shared by every resolveXFromSolicitorGroup function below - which group a premium
// setting/wizard step is scoped to (edit mode uses the setting's own group; create mode uses whatever's
// selected on the Premium Settings page). Not exported: callers that need a specific field call one of
// the resolvers below, which pick the right fallback for a group list that hasn't loaded yet.
const findSelectedSolicitorGroup = (premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup) => {
    const solicitorGroupId = premiumSettingsWizard.isEditMode && premiumSettingsWizard.solicitorGroupId
        ? premiumSettingsWizard.solicitorGroupId
        : selectedSolicitorGroup;

    if (solicitorGroupId === '' || solicitorGroupId === null || solicitorGroupId === undefined) {
        return null;
    }
    const solicitorGroup = (solicitorGroups || []).find(group => group && group.id !== null && group.id !== undefined
        && group.id.toString() === solicitorGroupId.toString());
    return solicitorGroup ?? null;
};

export const resolveSolicitorGroupAragProviderId = (premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup) => {
    const solicitorGroup = findSelectedSolicitorGroup(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup);
    if (solicitorGroup) return solicitorGroup.aragProviderId ?? null;

    // group list not loaded (a deep link straight to the edit route) - the setting speaks for its own group
    return premiumSettingsWizard.isEditMode
        ? premiumSettingsWizard.solicitorGroupAragProviderId ?? null
        : null;
};

// The read-only selected-group label's ARAG Provider colour marker for an edited
// setting - the edit-mode counterpart to resolveSolicitorGroupAragProviderId's group.aragProviderId
// lookup, but returning the full aragProvider object (providerColour and all) that
// formatSolicitorOptionLabel needs, not just the id. Only the edit-mode case needs this lookup:
// creating or copying a setting already has the full matched group object in scope at the point
// selectedSolicitorGroupName is set (see premiumSettingsCopyForm.js), so
// selectedSolicitorGroupAragProvider is populated directly there instead.
export const resolveEditedSolicitorGroupAragProvider = (premiumSettingsWizard, solicitorGroups) => {
    const solicitorGroupId = premiumSettingsWizard.solicitorGroupId;
    if (solicitorGroupId === '' || solicitorGroupId === null || solicitorGroupId === undefined) return null;

    const solicitorGroup = (solicitorGroups || []).find(
        group => group && group.id !== null && group.id !== undefined
            && group.id.toString() === solicitorGroupId.toString());

    return solicitorGroup?.aragProvider ?? null;
};

// GPL AC1/AC2 - the sibling of resolveSolicitorGroupAragProviderId for the one extra piece of
// information the underwriter-premium lock needs: whether that group is Green/LEI. Shares
// findSelectedSolicitorGroup's exact group-selection logic so the two can never disagree about which
// group they're describing.
export const resolveIsGplSolicitorGroup = (premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup) => {
    const solicitorGroup = findSelectedSolicitorGroup(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup);
    if (solicitorGroup) return !!solicitorGroup.isGplSolicitorGroup;

    // group list not loaded (a deep link straight to the edit route) - the setting speaks for its own group
    const isGplSolicitorGroup = premiumSettingsWizard.isEditMode
        ? !!premiumSettingsWizard.isGplSolicitorGroup
        : false;
    return isGplSolicitorGroup;
};

// WI 99823: the single place that compares a provider code against "PLC". Case/whitespace-tolerant,
// matching the backend's GplUnderwriterPremiumHelper.IsPlcProviderCode - every guard reads "not PLC"
// as its safe default, so a mismatch must not silently disable them.
export const isPlcProviderCode = (providerCode) =>
    typeof providerCode === 'string' && providerCode.trim().toUpperCase() === ARAG_PROVIDER_CODE_PLC.toUpperCase();

// WI 99823: the PLC sibling of resolveIsGplSolicitorGroup. "Not GPL" also catches Canada, so PLC has to
// be identified by the group's actual ProviderCode, not by inverting the Green/LEI flag.
export const resolveIsPlcSolicitorGroup = (premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup) => {
    const solicitorGroup = findSelectedSolicitorGroup(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup);
    if (solicitorGroup) return isPlcProviderCode(solicitorGroup.aragProvider?.providerCode);

    // group list not loaded (a deep link straight to the edit route) - the setting speaks for its own group
    return premiumSettingsWizard.isEditMode
        ? isPlcProviderCode(premiumSettingsWizard.solicitorGroupAragProviderCode)
        : false;
};

// Single source of truth for "which group is this premium setting scoped to, and what do we need to
// know about it" - combines the resolvers above into one call so a page only ever resolves the
// selected group once, instead of every caller independently re-running the same lookup with its own
// chance to disagree with the others.
//
// WI 99823: does not carry a Default-Premium-Setting flag (a Default setting has no group to resolve) -
// that check lives in premiumSettingsWizardHOC, combined with isPlcSolicitorGroup into nonContingentLocked.
export const resolveSelectedSolicitorGroupInfo = (premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup) => ({
    aragProviderId: resolveSolicitorGroupAragProviderId(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup),
    isGplSolicitorGroup: resolveIsGplSolicitorGroup(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup),
    isPlcSolicitorGroup: resolveIsPlcSolicitorGroup(premiumSettingsWizard, solicitorGroups, selectedSolicitorGroup),
});

// A solicitor group can only be created out of firms and underwriters that all belong to one ARAG
// provider, so the form can say so before posting rather than after a rejected round trip.
//
// Deliberately only reports a disagreement it can actually see: entries whose provider is unknown
// (a firm the search returned without one, an underwriter list that has not loaded yet, the
// placeholder {id: 0} the reducer starts with) are skipped rather than counted as a mismatch, so a
// gap in the data can never block a save on its own. GroupsService is the authority and rejects
// those cases with the very same message - this check only spares the user the round trip.
export const selectedSolicitorGroupEntitiesShareAragProvider = (selectedSolicitors, groupUnderwriters, underwriters) => {
    const firmProviderIds = (selectedSolicitors || []).map(solicitor => solicitor?.aragProvider?.id);
    const underwriterProviderIds = (groupUnderwriters || []).map(groupUnderwriter =>
        (underwriters || []).find(underwriter => underwriter.id === groupUnderwriter?.underwriterId)?.aragProviderId);

    const knownProviderIds = [...firmProviderIds, ...underwriterProviderIds].filter(id => id !== null && id !== undefined);

    return knownProviderIds.every(id => id === knownProviderIds[0]);
};

// Identity check for the "gATEway-PLUTUS-Lawsys" System of Record, the gate for whether the Financials
// tab exists for a policy at all (see policyTabs.js / applicationPolicyPageContent.js). Compares against
// SYSTEM_OF_RECORD_GATEWAY_PLUTUS_LAWSYS (helpers/constants.js), which mirrors
// GatewayCore.DLL/Helpers/SystemsOfRecordIds.GatewayPlutusLawsys byte-for-byte.
//
// Deliberately compares the GUID, never the display name (SystemsOfRecordIds.GetName) - the name is a
// derived label that can be renamed/localised without changing identity, so comparing on it would be
// comparing the wrong thing entirely.
//
// Deliberately case-insensitive: .NET's default Guid ToString("D") emits lowercase, which is why a plain
// `===` against the literal worked in practice - but that's an accident of the current serialiser, not a
// guarantee. A custom JsonConverter, a hand-built test fixture, or a future serialisation change that
// emits uppercase would make `===` silently return false for every policy on this System of Record,
// hiding the Financials tab with nothing to log the mismatch (the GUID is a feature-gate identity, and an
// identity check that can silently stop matching is exactly the kind of failure that goes unnoticed).
// Normalising both sides to lowercase here removes that failure mode without weakening the identity
// check itself - it's still comparing the same GUID, just ignoring a formatting detail that isn't part
// of its meaning.
//
// `systemsOfRecordId` may be null/undefined (e.g. a policy still loading, or one with no System of Record
// assigned yet) - `|| ''` guards that so the function returns false instead of throwing.
export const isGatewayPlutusLawsys = (systemsOfRecordId) =>
    (systemsOfRecordId || '').toLowerCase() === SYSTEM_OF_RECORD_GATEWAY_PLUTUS_LAWSYS.toLowerCase();